import client from './_client'
import store from '../../store'
import verifyUser from '../interceptor'

const API_TOKEN = process.env.VUE_APP_API_TOKEN

client.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    if (error.response?.status === 403) {
      const authToken = store.getters['auth/authToken']
      await verifyUser(authToken)
    }
    return Promise.reject(error)
  }
)

export default {
  getBusinessDetails(businessId) {
    return client({
      method: 'GET',
      url: `api/v1/businesses/${businessId}?withBranding=true`,
      headers: {
        'auth-token': store.getters['auth/authToken'],
        'api-token': API_TOKEN
      }
    })
  },
  getBusinessDetailsBySlug(businessSlug) {
    return client({
      method: 'GET',
      url: `api/v1businesses/slug/${businessSlug}?withBranding=true&rgba=false`,
      headers: {
        'auth-token': store.getters['auth/authToken'],
        'api-token': API_TOKEN
      }
    })
  }
}
